import React, {useCallback, useState} from "react";
import {formatMessage} from "devextreme/localization";
import {SingleCard} from "../../layouts";
import {Alert} from "../../components";
import Button from "devextreme-react/button";
import LoadIndicator from "devextreme-react/load-indicator";
import RadioGroup from "devextreme-react/radio-group";
import notify from "devextreme/ui/notify";
import {useAppState} from "../../contexts/app-state";

export default ({items, mfaDogrula }) => {
    const { state } = useAppState();
    const [isBusy, setIsBusy] = useState(false);
    const [mfa, setMfa] = useState(null);
    const [validationError, setValidationError] = useState(null);

    const onayKoduDogrula = useCallback(() => {
        setIsBusy(true)
        setValidationError(null)

        fetch('/ui/login/mfa-devam',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify( { mfa })
            })
            .then((response) => response.json())
            .then((res) => {
                if (res.success) {
                    mfaDogrula(res);
                } else {
                    setValidationError(res.message);
                    setIsBusy(false);
                }
            })
            .catch((error) => {
                notify(formatMessage('oops'), "error", 2000);
                if (state.debug) {
                    console.error(error);
                }
                setIsBusy(false);
            })
    })

    return <SingleCard hideFooter={true}
                       title={formatMessage('onayKodu.dogrulama')}
                       page="OnayKoduSayfa">
        {validationError && <Alert type="error"
                                   message={validationError}
                                   iconClass="fa fa-2x fa-exclamation-circle"/>}

            <div className="kq-form">
                <p style={{textAlign:"center"}}>

                    {formatMessage('onayKodu.mfaSec')}
                </p>
                <div className="kq-mfa-choice" style={{marginBottom:40}}>
                    <RadioGroup disabled={isBusy} items={items} onValueChanged={(e) => setMfa(e.value.id)} />
                </div>
                <Button width="100%"
                        type="default"
                        disabled={isBusy || mfa === null}
                        onClick={onayKoduDogrula}>
            <span className="dx-button-text">
              {
                  isBusy
                      ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                      : formatMessage('onayKodu.devamEt')
              }
            </span>
                </Button>
            </div>

    </SingleCard>
}
